function setHomeOffersHeight() {
  const cards = $('.homeoffers .homeoffers_job-link');
  let height = 0;

  cards.css('height', 'fit-content');

  cards.each(function(){
    if($(this).innerHeight() > height){
      height = $(this).innerHeight();
    }
  });

  cards.css('height', `${height}px`);

  setTimeout(()=>{
    setHomeOffersHeight();
  },500)}


jQuery(document).ready(function () {

  setHomeOffersHeight();

  if ($(".homeoffers").length > 0) {
    var allReal = $(".homeoffers_job-link");
    var itemToDisplay = 4;
    var thematique;
    var allItem = allReal.length;

    function defineCardToDisplay() {
      $(".homeoffers_job-link:lt(" + itemToDisplay + ")").show();
    }
    defineCardToDisplay();

    $(".homeoffers_filterItem").click(function () {
      $(".homeoffers_filterItem").removeClass("homeoffers_filterItem-active");
      $(this).toggleClass("homeoffers_filterItem-active");
      thematique = $(this).attr("id");
      var thematiqueItem = $(".homeoffers_job-" + thematique).length;
      allItem = thematiqueItem;
      
      allReal.hide();
      var count = 0;
      allReal.each(function (index) {
        if ($(this).data(thematique)) {
          if (count < itemToDisplay) {
            $(this).show();
            count++;
          }
        }
      });
    });

    function filterOption() {
      var allcategory = $(".homeoffers_categorie-title");
      var categoryTab = [];
      allcategory.each(function () {
        categoryTab.push($(this).text());
      });
      const unique = (arr) => [...new Set(arr)];

      categoryTab = unique(categoryTab);

      var selectDrop = $(".homeoffers_filter-dropdown");
      var selectList = $(".homeoffers_filter-list");
      for (var i = 0; i < categoryTab.length; i++) {
        var category = categoryTab[i];
        category = category.trim();
        const test = $(".uxui");
        $.each(test.data(), function (i) {
          test.removeAttr("data-" + i);
        });
        test.attr("data-uxui", "1");
        test.addClass("homeoffers_job-uxui");

        var option = document.createElement("option");
        option.setAttribute("value", "category");
        option.textContent = category;
        option.value = category;
        selectDrop.append(option);
        selectList.append(
          "<li class='homeoffers_filter-listItem'>" + category + "</li>"
        );
      }

      /* Filter with change on select */

      selectDrop.on("change", function () {
        thematique = this.value;
        allReal.hide();
        var thematiqueItem = $(".homeoffers_job-" + thematique).length;
        allItem = thematiqueItem;
        if (thematique == "") {
          $(".homeoffers_job-link:lt(" + itemToDisplay + ")").show();
        } else {
          $(
            ".homeoffers_job-" + thematique + ":lt(" + itemToDisplay + ")"
          ).show();
        }
      });
    }
    filterOption();

    /* Filter with list */

    /* Transform in square */

    function square() {
      var jobHeight = $(".homeoffers_job").outerWidth();
      $(".homeoffers_job-link").height(jobHeight);
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
       
    } else{
        square();
    }
   


    function filterDesktop(){
        var selectListItem = $('.homeoffers_filter-listItem');
        selectListItem.on('click', function () {
            $('.homeoffers_filter-listActive').removeClass('homeoffers_filter-listActive')
            thematique = $(this).text();
            $(this).addClass('homeoffers_filter-listActive')
            allReal.hide();
            var thematiqueItem = $(".homeoffers_job-" + thematique).length;
            allItem = thematiqueItem;
            if (thematique == "Les plus récentes") {
              $(".homeoffers_job-link:lt(" + itemToDisplay + ")").show();
            } else {
              $(
                ".homeoffers_job-" + thematique + ":lt(" + itemToDisplay + ")"
              ).show();
            }

        })
        
    }
    filterDesktop();
  }
});
